// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__nmYVR","paramInput":"JobSimulator_paramInput__1Y26x","input":"JobSimulator_input__2JunP"};